import * as d3 from 'd3';

export type KeyCentre =
    "C" |
    "F" |
    "Bb" |
    "Eb" |
    "Ab" |
    "C#" |
    "F#" |
    "B" |
    "E" |
    "A" |
    "D" |
    "G";

const keyCentres = [
    "C",
    "F",
    "Bb",
    "Eb",
    "Ab",
    "C#",
    "F#",
    "B",
    "E",
    "A",
    "D",
    "G",
];

interface KeyCentreCount {
    keyCentre: KeyCentre;
    count: number;
}

interface Props {
    height: number,
    width: number,
    counts: KeyCentreCount[]
}

export const CycleOfFifthsChart = (props: Props) => {

    const innerRadius = 80;
    const outerRadius = Math.min(props.width, props.height) / 2;
    var textRadius = 60;

    const categoryScale = d3.scaleBand()
        .domain(keyCentres)
        .range([-Math.PI / 12, 2 * Math.PI - Math.PI / 12]);

    const countScale = d3.scaleLinear()
        .domain([0, d3.max(props.counts.map(keyCentreCount => keyCentreCount.count)) as any])
        .range([innerRadius, outerRadius]);

    const opacityScale = d3.scaleLinear()
        .domain([0, d3.max(props.counts.map(keyCentreCount => keyCentreCount.count)) as any])
        .range([0, 100]);

    const colorScale = d3.scaleLinear()
        .domain(d3.extent(props.counts.map(keyCentreCount => keyCentreCount.count)) as any[])
        .range(['blue', 'red'] as any);

    const textRotate = d3.scaleBand()
        .domain(keyCentres)
        .range([0, 360]);
        
    return (
        <svg
            height={props.height}
            width={props.width}
            >
            <g
                transform={"translate(" + props.width / 2 + "," + props.height / 2 + ")"}
                >
                {
                    keyCentres.map(keyCentre =>
                        <text
                            key={keyCentre}
                            x={0}
                            y={-textRadius}
                            transform={"rotate(" + textRotate(keyCentre) + ")"}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            opacity={opacityScale((props.counts.find(count => count.keyCentre === keyCentre) as any).count) + "%"}
                            >
                            {keyCentre}
                        </text>)
                }
            </g>
            <g
                transform={"translate(" + props.width / 2 + "," + props.height / 2 + ")"}
                >
                {
                    props.counts.map(keyCentreCount =>
                        {
                            const path = d3.arc()
                                .innerRadius(countScale(0) as any)
                                .outerRadius(((bin: KeyCentreCount) => countScale(bin.count)) as any)
                                .startAngle(((bin: KeyCentreCount) => categoryScale(bin.keyCentre)) as any)
                                .endAngle(((bin: KeyCentreCount) => categoryScale(bin.keyCentre) as any + categoryScale.bandwidth()) as any)
                                .padAngle(0.05)
                                .padRadius(innerRadius);
                            return (
                                <path
                                    key={keyCentreCount.keyCentre}
                                    fill={colorScale(keyCentreCount.count).toString()}
                                    fillOpacity="80%"
                                    d={path(keyCentreCount as any) as string}
                                    >

                                </path>
                            );
                        })
                }
            </g>
        </svg>
    );
}
  